/**
 * DragIndicatorIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const DragIndicatorIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M14.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M9.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m6.5-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const DragIndicatorIcon = makeIcon('DragIndicatorIcon', DragIndicatorIconSvg)
